import React, { PureComponent } from "react";
import { getSentimentColor, downloadCSVData, downloadCanvasWithTitle, getViewConversationDuration } from "../utils";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import moment from "moment-timezone";
import NoData from "../NoData/NoData";
import CustomCheckBox from "../ChartsOptionsSidebar/CustomCheckBox";
import IntervalSelector from "../IntervalSelector";
import html2canvas from "html2canvas";
import { ReactComponent as MoreOptions } from "../../../../../assets/svg/menu.svg";
import { ReactComponent as Settings } from "../../../../../assets/svg/settings.svg";
import { showChartsDrilldown } from "../../../../../actions/dashboardAction";
import ChartOptionsSidebar from "../ChartsOptionsSidebar/ChartOptionsSidebar";
import DeleteWidget from "../ChartsOptionsSidebar/DeleteWidget";
import { ReactComponent as CloneIcon } from "../../../../../assets/svg/clone-icon.svg";
import HighchartsCustomEvents from "highcharts-custom-events";
import { ChartFilterIcon } from "../ChartFilterOptions";
import ChartName from "../ChartName";
import { connect } from "react-redux";
import DownloadChart from "../DownloadChart";
import { ReactComponent as MiniMize } from "../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import * as d3 from "d3";

import { numberWithCommas } from "../utils";
import { ReactComponent as ComparisionIcon } from "../../../../../assets/svg/CompareChartIcon.svg";
import UpIcon from "../../../../../assets/svg/percentage_arrow.svg";
import DownIcon from "../../../../../assets/svg/arrow-down.svg";

HighchartsCustomEvents(Highcharts);
class PositiveSentimentPercentOverTime extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showInfo: false,
            showAverage: true,
            showGridLines: false,
        };
        this.chartEl = React.createRef();
        this.chartComponent = React.createRef();
    }

    // componentDidUpdate(prevProps) {
    //     if (this.props.resizedCount !== prevProps.resizedCount && this.chartComponent) {
    //         this.chartComponent.current && this.chartComponent.current.chart.setSize(null, null);
    //         this.chartComponent.current && this.chartComponent.current.chart.reflow();
    //     }
    // }

    componentDidMount() {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent?.current?.chart.setSize(null, null);
                this.chartComponent?.current?.chart.reflow();
            }, 0);
        });
        if (this.props.widgetContainerRef.current) {
            this.ro.observe(this.props.widgetContainerRef.current);
        }
    }

    componentWillUnmount() {
        this.ro.disconnect();
    }

    toggleGridLines(d) {
        this.setState({
            showGrids: d.checked,
        });
    }

    showAverage = () => {
        this.setState({ showAverage: !this.state.showAverage });
    };

    showGridLines = () => {
        this.setState({ showGridLines: !this.state.showGridLines });
    };

    formatData(data) {
        let res = {};
        let columns = [];

        let total = new Array(data.xs.length).fill(0);
        let positives = new Array(data.xs.length).fill(0);

        for (let i = 0; i < positives.length; i++) {
            positives[i] = data.data["positive"][i];
        }

        // Axes
        let positivePercentOverTime = new Array(data.xs.length).fill(0);

        Object.values(data.data).forEach((arr) => {
            arr.forEach((val, ind) => {
                total[ind] += val;
            });
        });
        columns.push(["x"].concat(data.xs));

        for (let i = 0; i < positivePercentOverTime.length; i++) {
            if (positives[i] === 0 && total[i] === 0) {
                positivePercentOverTime[i] = 0;
                positivePercentOverTime[i] = Number(positivePercentOverTime[i]).toFixed(2);
            } else {
                positivePercentOverTime[i] = Number((positives[i] / total[i]) * 100).toFixed(2);
            }
            positivePercentOverTime[i] = parseFloat(positivePercentOverTime[i]);
        }
        columns.push(["Positive"].concat(positivePercentOverTime));
        res.columns = columns;
        return res;
    }

    isHourly(data) {
        if (data.xs.length < 2) return false;
        return data.xs[1] - data.xs[0] < 24 * 59 * 60 * 1000;
    }

    getTodaysAverage(data, isHourly) {
        let total = new Array(data.xs.length).fill(0);
        let positives = new Array(data.xs.length).fill(0);

        // Check if 24 hours or not
        let pos = -1;

        if (isHourly) {
            let userTz = JSON.parse(localStorage.getItem("company")).user_timezone_name;
            let currentDay = moment(data.xs[data.xs.length - 1])
                .tz(userTz)
                .date();
            for (let i = 0; i < data.xs.length; i++) {
                if (moment(data.xs[i]).tz(userTz).date() === currentDay) {
                    pos = i;
                    break;
                }
            }
        }

        for (let i = 0; i < positives.length; i++) {
            positives[i] = data.data["positive"][i];
        }

        Object.values(data.data).forEach((arr) => {
            arr.forEach((val, ind) => {
                total[ind] += val;
            });
        });

        if (!isHourly) {
            return ((positives[data.xs.length - 1] / total[data.xs.length - 1]) * 100).toFixed(0);
        } else {
            if (pos !== -1) {
                let todayPositives = data.data["positive"].slice(pos);
                let todayTotal = total.slice(pos);

                let positiveTotal = todayPositives.reduce((total, count) => total + count, 0);
                let totalCount = todayTotal.reduce((sum, count) => sum + count, 0);
                return ((positiveTotal / totalCount) * 100).toFixed(0);
            } else {
                let positiveTotal = data.data["positive"].reduce((total, count) => total + count, 0);
                let totalCount = total.reduce((sum, count) => sum + count, 0);
                return ((positiveTotal / totalCount) * 100).toFixed(0);
            }
        }
    }

    getAvgBands(data) {
        let values = [0, 0];
        let positives = this.formatData(data).columns[1].slice(1);
        let tpAverage = parseFloat(this.getTimePeriodAverage(data));
        let absAverages = 0;
        let diff = 0;

        for (let i = positives.length - 1; i >= 1; i--) {
            diff = positives[i] - positives[i - 1];

            absAverages += Math.abs(diff);
        }

        absAverages = absAverages / positives.length;
        absAverages = absAverages * 2.66;

        values[0] = (tpAverage + absAverages).toFixed(0);
        values[1] = (tpAverage - absAverages).toFixed(0);

        return values;
    }

    getTimePeriodAverage(data) {
        if (data && data.xs.length) {
            let total = new Array(data.xs.length).fill(0);
            let positives = new Array(data.xs.length).fill(0);

            for (let i = 0; i < positives.length; i++) {
                positives[i] = data.data["positive"][i];
            }

            Object.values(data.data).forEach((arr) => {
                arr.forEach((val, ind) => {
                    total[ind] += val;
                });
            });

            let totalCount = total.reduce((total, item) => total + item, 0);
            let positiveCount = positives.reduce((total, item) => total + item, 0);

            return ((positiveCount / totalCount) * 100).toFixed(0);
        } else {
            return 0;
        }
    }

    formatDataCsv = (data) => {
        let res = {};
        let columns = [];
        let dataL = [];
        let dataComparision = [];
        let total = new Array(data.xs.length).fill(0);
        Object.values(data.data).forEach((arr) => {
            arr.forEach((val, ind) => {
                total[ind] += val;
            });
        });
        data.data.positive.forEach((y, i) => {
            dataL.push(total[i] <= 0 ? 0 : +((y / total[i]) * 100).toFixed(2));
        });

        columns.push(["x"].concat(data.xs));
        columns.push(["Positive Sentiment (%)"].concat(dataL));

        let comparetotal;
        if (this.props.comparisionData) {
            comparetotal = new Array(this.props.comparisionData.data.xs.length).fill(0);
            Object.values(this.props.comparisionData.data.data).forEach((arr) => {
                arr.forEach((val, ind) => {
                    comparetotal[ind] += val;
                });
            });

            this.props.comparisionData.data.data.positive.forEach((y, i) => {
                dataComparision.push(comparetotal[i] <= 0 ? 0 : +((y / comparetotal[i]) * 100).toFixed(2));
            });
        }
        if (this.props.comparisionData) {
            columns.push(["Comparison Time"].concat(this.props.comparisionData.data.xs));
            columns.push(["Comparison Unique Users Data"].concat(dataComparision));
        }

        res.columns = columns;
        return res;
    };

    downloadCSV = () => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        let data = this.formatDataCsv(this.props.data.data);
        let formatString = "YYYY-MM-DD HH:mm";
        let userTz = JSON.parse(localStorage.getItem("company")).user_timezone_name;
        data.columns[0] = data.columns[0].map((d) => (d === "x" ? "x" : moment(d).tz(userTz).format(formatString)));
        if (this.props.comparisionData) {
            data.columns[2] = data.columns[2].map((d) => (d === "Comparison Time" ? "Comparison Time" : moment(d).tz(userTz).format(formatString)));
        }
        // let csvFmt;
        // if (this.props.comparisionData) {
        //     csvFmt = data.columns[3].map((col, i) => data.columns.map((row) => (row[i] ? row[i] : "  ")));
        // } else {
        //     csvFmt = data.columns[0].map((col, i) => data.columns.map((row) => row[i]));
        // }
        // csvFmt[0][0] = "Time";

        // downloadCSVData(csvFmt, this.props.widget.name);

        let firstIndLen = data.columns[0].length;
        let lastIndLen = data.columns[data.columns.length - 1].length;

        let length;
        if (firstIndLen > lastIndLen) length = firstIndLen;
        else length = lastIndLen;

        let arr = [];
        for (let i = 0; i < length; i++) {
            arr.push([]);
            for (let j = 0; j < data.columns.length; j++) {
                if (data.columns[j] && data.columns[j][i]) arr[i].push(data.columns[j][i]);
                else arr[i].push(0);
            }
        }

        arr[0][0] = "Time";

        downloadCSVData(arr, this.props.widget.name);
    };

    downloadPNG = (cb, options) => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }

        html2canvas(this.chartEl.current, { backgroundColor: options.background ? "#fff" : null, allowTaint: true, useCORS: true }).then((canvas) => {
            cb && cb();
            downloadCanvasWithTitle(canvas, this.props.widget.name);
        });
    };

    renderDownloadButton(nodata) {
        return (
            <DownloadChart
                nodata={nodata}
                options={[
                    { name: "CSV", downloadFn: this.downloadCSV },
                    {
                        name: "PNG",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: true,
                    },
                    {
                        name: "PNG(Transparent)",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: false,
                    },
                ]}
            />
        );
    }

    addContextMenuListener(x, y, chart) {
        if (this.props.isPublic) return;
        let self = this;
        let contextMenu = d3.select(".dashboard-charts-contextmenu");

        contextMenu.attr("data-type", "clickedMenu");
        contextMenu.style("top", `${y + 10}px`);
        contextMenu.style("left", `${x - 82}px`);
        contextMenu.style("background", `#fff`);
        contextMenu.style("color", `#1a1a1a`);
        contextMenu.html(null);
        contextMenu
            .append("li")
            .text("View Conversations")
            .on("click", () => {
                self.handleContextMenuClick(chart);
            });
        contextMenu
            .append("li")
            .text("View Insights")
            .on("click", () => {
                // console.log('drilldown')
                self.handleDrilldownClick(chart);
                // this.props.showChartsDrilldown(true, "positiveSentimentPercentOverTime");
            });
        contextMenu.style("display", "block");
    }

    createNewFilter(d) {
        let newFilter = this.props.filters ? JSON.parse(JSON.stringify(this.props.filters)) : {};
        newFilter.extras = [{ key: "Sentiment", value: "positive" }];
        if (d.originalX) {
            d.x = d.originalX;
        }

        let lastComparisonIndex = false;
        lastComparisonIndex = d.index === d.series.points.length - 1 && d.color.endsWith("85");

        newFilter = getViewConversationDuration(
            d,
            newFilter,
            this.props.aggs_val,
            this.props.filters,
            this.props.comparisionData.data,
            lastComparisonIndex,
            this.props.comparisonAppliedFilter,
        );
        // newFilter = getViewConversationDuration(d, newFilter, this.props.aggs_val, this.props.filters);
        return newFilter;
    }

    handleContextMenuClick(d) {
        let newFilter = this.createNewFilter(d);
        this.props.handleContextMenuClick(newFilter);
    }

    handleDrilldownClick(d) {
        let newFilter = this.createNewFilter(d);

        this.props.handleDrilldownClick(newFilter);
    }

    getOptions = () => {
        let data = [];
        let comparisionData = [];
        let total = new Array(this.props.data.data.xs.length).fill(0);
        let totalComparision = this.props.comparisionData && new Array(this.props.comparisionData.data.xs.length).fill(0);

        let { aggs_val } = this.props;

        Object.values(this.props.data.data.data).forEach((arr) => {
            arr.forEach((val, ind) => {
                total[ind] += val;
            });
        });

        this.props.comparisionData &&
            Object.values(this.props.comparisionData.data.data).forEach((arr) => {
                arr.forEach((val, ind) => {
                    totalComparision[ind] += val;
                });
            });

        this.props.data.data.data.positive.forEach((y, i) => {
            data.push({ x: this.props.data.data.xs[i], y: !isNaN(+((y / total[i]) * 100).toFixed(2)) ? +((y / total[i]) * 100).toFixed(2) : 0 });
        });

        this.props.comparisionData &&
            this.props.comparisionData.data.data.positive.forEach((y, i) => {
                comparisionData.push({
                    x: this.props.comparisionData.data.xs[i],
                    y: !isNaN(+((y / totalComparision[i]) * 100).toFixed(2)) ? +((y / totalComparision[i]) * 100).toFixed(2) : 0,
                });
            });

        let isHourly = this.isHourly(this.props.data.data);
        let todaysAvg = this.getTodaysAverage(this.props.data.data, isHourly);
        let timePeriodAvg = this.getTimePeriodAverage(this.props.data.data);
        let avgBandValues = this.getAvgBands(this.props.data.data);

        let plotLines = this.props.showAverage
            ? [
                  {
                      color: "#008080",
                      dashStyle: "solid",
                      value: parseFloat(avgBandValues[0]),
                      width: 1,
                      label: {
                          style: {
                              color: "#008080",
                              marginTop: "2%",
                          },
                          text: `Average Upper Band : ${avgBandValues[0]}%`,
                          align: "left",
                          ///x: parseInt(avgBandValues[0]) - parseInt(timePeriodAvg) <= 5 ? -70 : -12,
                          //   x: -330,
                          //   y: -10,
                      },
                  },
                  {
                      color: "#daa520",
                      dashStyle: "solid",
                      value: parseFloat(avgBandValues[1]),
                      width: 1,
                      label: {
                          style: {
                              color: "#daa520",
                          },
                          text: `Average Lower Band : ${avgBandValues[1]}%`,
                          verticalAlign: top,
                          align: "right",
                      },
                  },
                  {
                      color: "#14892c",
                      dashStyle: "dot",
                      value: parseFloat(todaysAvg),
                      width: 2,
                      label: {
                          style: {
                              color: "#14892c",
                          },
                          text: `Today's Average : ${todaysAvg}%`,
                          align: "left",
                          y: 20,
                      },
                  },
                  {
                      color: "#800080",
                      dashStyle: "dot",
                      value: parseFloat(timePeriodAvg),
                      width: 2,
                      label: {
                          style: {
                              color: "#800080",
                          },
                          text: `Time Period Average : ${timePeriodAvg}%`,
                          align: "right",
                          y: 20,
                      },
                  },
              ]
            : [];

        let avgComparisionBandValues = this.props.comparisionData && this.getAvgBands(this.props.comparisionData.data);

        let highY = Math.max.apply(
            Math,
            data.map(function (o) {
                return o.y;
            }),
        );
        let lowY = Math.min.apply(
            Math,
            data.map(function (o) {
                return o.y;
            }),
        );

        if (highY === lowY) {
            highY = highY + 0.5;
            lowY = lowY - 0.5;
        }

        let maxVal = isNaN(highY) || avgBandValues[0] > highY ? avgBandValues[0] : highY;
        let minVal = isNaN(lowY) || avgBandValues[1] < lowY ? avgBandValues[1] : lowY;

        if (minVal === maxVal) {
            minVal = minVal - 10;
            //maxVal = 100;
        }

        let maxValComparision;
        let minValComparision;

        let self = this;
        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let tzo = JSON.parse(localStorage.company).user_timezone * -60;

        if (this.props.comparisionData) {
            let highYComparision = Math.max.apply(
                Math,
                comparisionData.map(function (o) {
                    return o.y;
                }),
            );
            let lowYComparision = Math.min.apply(
                Math,
                comparisionData.map(function (o) {
                    return o.y;
                }),
            );

            maxValComparision = isNaN(highYComparision) || avgComparisionBandValues[0] > highYComparision ? avgComparisionBandValues[0] : highYComparision;
            minValComparision = isNaN(lowYComparision) || avgComparisionBandValues[1] < lowYComparision ? avgComparisionBandValues[1] : lowYComparision;

            if (minValComparision === maxValComparision) {
                minValComparision = minValComparision - 10;
                //maxVal = 100;
            }
        }

        let plotComaprisiondata;

        let plotComaprisiondataCondition = comparisionData && comparisionData.length >= data.length;

        if (plotComaprisiondataCondition && data) {
            plotComaprisiondata = JSON.parse(JSON.stringify(data));

            comparisionData.forEach((element, ind) => {
                if (plotComaprisiondata[ind]) {
                    plotComaprisiondata[ind].originalX = plotComaprisiondata[ind].x;
                    plotComaprisiondata[ind].x = element.x;
                }
            });
        } else {
            if (comparisionData) {
                plotComaprisiondata = JSON.parse(JSON.stringify(comparisionData));
                data &&
                    data.forEach((element, ind) => {
                        if (plotComaprisiondata[ind]) {
                            plotComaprisiondata[ind].originalX = plotComaprisiondata[ind].x;
                            plotComaprisiondata[ind].x = element.x;
                        }
                    });
            }
        }

        const optionsPositive = {
            chart: {
                type: "spline",
                backgroundColor: "transparent",
                spacingTop: maxVal >= 100 ? 25 : 15,
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
                spacingBottom: 5,
            },
            legend: {
                enabled: this.props.showLegendLine,
            },
            credits: {
                enabled: false,
            },
            title: {
                text: " ",
            },
            xAxis: {
                type: "datetime",
                dateTimeLabelFormats: {
                    millisecond: "%l:%M %p",
                    second: "%l:%M %p",
                    minute: "%l:%M %p",
                    hour: "%l:%M %p",
                    day: "%e %b",
                    week: "%e. %b",
                    month: "%b '%y",
                    year: "%Y",
                },
                labels: {
                    style: {
                        textTransform: "normal",
                    },
                },
            },
            yAxis: {
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "ShortDash",
                gridLineColor: this.props.comparisionData ? "#ccd6eb" + "55" : "#ccd6eb",
                lineColor: this.props.comparisionData ? "#ccd6eb" + "55" : "#ccd6eb",
                lineWidth: 1,
                // max: this.props.comparisionData
                //     ? maxValComparision >= 100
                //         ? 100
                //         : parseInt(maxValComparision) + 1
                //     : maxVal >= 100
                //     ? 100
                //     : parseInt(maxVal) + 1,
                // min: this.props.comparisionData ? parseInt(minValComparision) : parseInt(minVal),
                plotLines: this.props.comparisionData ? [] : plotLines,
                title: "",
                labels: {
                    formatter: function () {
                        return '<p style="padding-top: 20px">' + this.value + "%" + "</p>";
                    },
                },
            },
            series: this.props.comparisionData
                ? [
                      {
                          name: `${moment(this.props.data.data.date.start_date).format("DD MMM YYYY")} - ${moment(this.props.data.data.date.end_date).format(
                              "DD MMM YYYY",
                          )}`,
                          data: comparisionData.length >= data.length ? plotComaprisiondata : data,
                          // data: data,
                          color: getSentimentColor("positive"),
                          //   dataLabels: {
                          //       color: "red",

                          //   },
                      },
                      {
                          name: `${moment(this.props.comparisionData.data.date.start_date).format("DD MMM YYYY")} - ${moment(
                              this.props.comparisionData.data.date.end_date,
                          ).format("DD MMM YYYY")}`,
                          data: comparisionData.length < data.length ? plotComaprisiondata : comparisionData,
                          // data: comparisionData,
                          //  xAxis: 1,
                          color: getSentimentColor("positive") + "85",
                          //   dataLabels: {
                          //       color: "red" + "85",
                          //   },
                      },
                  ]
                : [
                      {
                          name: "Positive ",
                          data: data,
                          color: getSentimentColor("positive"),
                          //   dataLabels: {
                          //       color: "red",
                          //   },
                      },
                  ],
            plotOptions: {
                series: {
                    marker: {
                        symbol: "circle",
                        radius: 4,
                    },
                    // {
                    //     symbol: "triangle-down",
                    //     radius: 4,
                    // },
                    // ],
                },
                spline: {
                    point: {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault();
                                self.addContextMenuListener(e.x, e.y, Object.assign({}, this));
                            },
                        },
                    },
                },
            },
            time: {
                timezoneOffset: tzo,
            },

            tooltip: {
                shared: plotComaprisiondata ? true : false,
                crosshairs: true,
                backgroundColor: "#fff",
                borderRadius: 6,
                useHTML: true,
                followPointer: true,
                followTouchMove: true,

                formatter: function () {
                    if (plotComaprisiondata) {
                        let str = "";
                        let ComapareVal1;
                        let ComapareVal2;
                        let dateCompare;
                        for (let i = 0; i < this.points.length; i++) {
                            let temp = "";
                            ComapareVal1 = this.points[0].y;
                            ComapareVal2 = this.points[1]?.y;
                            dateCompare = this.points[1]?.point.options.originalX > this.points[1]?.point.options.x;
                            temp = `<b>${moment(
                                this.points[i].point.options.originalX ? this.points[i].point.options.originalX : this.points[i].point.options.x,
                            )
                                .tz(tz)
                                .format(
                                    "LLLL",
                                )}</b><br/><div style="margin-bottom:10px;"><span style="margin-right:10px;display:inline-block;width:8px;height:8px;background-color:${
                                this.points[i].color
                            };border-radius:10px" ></span>
                          
                            <b>${numberWithCommas(this.points[i].y)}</b> </div>`;

                            str += temp;
                        }
                        if (this.points.length == 2) {
                            str += `${
                                ComapareVal1 < ComapareVal2
                                    ? `<div> <div style="display:flex;align-item:center"><b>${
                                          ComapareVal1 !== 0 ? (((ComapareVal2 / ComapareVal1).toFixed(2) - 1) * 100).toFixed(2) + "%" : "NA"
                                      }</b>
                                   
                                <img src=${dateCompare ? UpIcon : DownIcon} width="16px" height="16px" style="margin-left:5px;transform:${
                                          dateCompare && "rotate(180deg)"
                                      }" />
                                </div>
                             
                            
                            
                                
                                </div>`
                                    : ComapareVal1 > ComapareVal2
                                    ? `<div> <div style="display:flex;align-item:center"><b>${
                                          ComapareVal2 !== 0 ? (((ComapareVal1 / ComapareVal2).toFixed(2) - 1) * 100).toFixed(2) + "%" : "NA"
                                      }</b>
                                   
                                    <img src=${dateCompare ? DownIcon : UpIcon} width="16px" height="16px" style="margin-left:5px;transform:${
                                          !dateCompare && "rotate(180deg)"
                                      }" />
                                    </div>
                                 
                                
                                
                                    
                                    </div>`
                                    : ""
                            }`;
                        }

                        return str;
                    } else {
                        return `${moment(this.x).tz(tz).format("LLLL")}<br/>${this.point?.series?.name}: <b>${numberWithCommas(this.y)}</b>`;
                    }
                },
            },
            // tooltip: {
            //     outside: true,
            //     backgroundColor: "#fff",
            //     // shadow: false,
            //     borderRadius: 6,
            //     style: {},
            //     formatter: function () {
            //         let a = moment(this.x).tz(tz).format("LLLL");

            //         return `<span>${a}</span><br/><span>Positive: </span><b>${this.point.options.y}%</b>`;
            //     },
            // },
        };

        return optionsPositive;
    };

    handleIntervalChange = (val) => {
        this.props.handleIntervalChange(val);
    };

    render() {
        let nodata = !this.props.data || (this.props.data && this.props.data.nodata) || this.props.noTopicsSelected;

        return (
            <>
                <div className="dashboard-widget-container-header skiptranslate">
                    <ChartName
                        name={this.props.widget.name}
                        info="Represents percentage of positive sentiment over time. There are two average lines for today as well as for the date range selected in the filter."
                    />
                    <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                        {!this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <Popup
                                    content="Chart Comparison Filters"
                                    position="bottom center"
                                    size="tiny"
                                    inverted
                                    className="skiptranslate"
                                    trigger={
                                        <div className={`chart-header-icon`} onClick={() => (!this.props.isPublic ? this.props.chartComparision() : null)}>
                                            <ComparisionIcon className={`comparision-filter${this.props.chartComparisionFilterApplied ? "-applied" : ""}`} />
                                        </div>
                                    }
                                />
                            )}
                        {!this.props.isPublic &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <ChartFilterIcon
                                    chartFilterApplied={this.props.chartFilterApplied}
                                    changeShowChartFilterOptions={this.props.changeChartFilter}
                                    widgetListDashboardCurrent={this.props.widgetListDashboardCurrent}
                                    name={this.props.widget.name}
                                />
                            )}
                        {!this.props.isPublic && !this.props.isResearchDashboard && this.renderDownloadButton(nodata)}
                        {
                            <>
                                {this.props.isPublic && nodata ? null : (
                                    <Popup
                                        className="skiptranslate"
                                        trigger={
                                            this.props.expandWidget ? (
                                                <MiniMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            ) : (
                                                <MaxiMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            )
                                        }
                                        inverted
                                        content={this.props.expandWidget ? "Minimize Widget" : "Maximize Widget"}
                                        size="mini"
                                        position="bottom center"
                                        style={{ zIndex: "99999" }}
                                    />
                                )}
                            </>
                        }
                        {this.props.isPublic && nodata ? null : <MoreOptions className="more-options" onClick={(e) => this.props.changeShowMoreOptions(e)} />}
                    </div>
                </div>
                {this.props.showMoreOptions && (
                    <ChartOptionsSidebar
                        data-html2canvas-ignore="true"
                        showMoreOptionsLoc={this.props.showMoreOptionsLoc}
                        changeShowMoreOptions={this.props.changeShowMoreOptions}>
                        {!nodata && <CustomCheckBox checked={this.props.showLegendLine} onClick={this.props.changeShowLegendLine} label="Show Legends" />}
                        {!nodata && <CustomCheckBox checked={this.props.showGridLines} onClick={this.props.changeShowGridLines} label="Show Grid Lines" />}
                        {!nodata && <CustomCheckBox checked={this.props.showAverage} onClick={this.props.changeShowAverage} label="Show Averages" />}
                        {!nodata && (
                            <IntervalSelector
                                aggs_val={this.props.aggs_val}
                                appliedFilter={this.props.appliedFilter}
                                handleIntervalChange={this.props.handleIntervalChange}
                                disableComparisonInterval={this.props.disableComparisonInterval}
                            />
                        )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <>
                                    <div className="chart-settings menu-option" onClick={this.props.chartSettings}>
                                        <span>Chart Configuration</span>
                                        <Settings />
                                    </div>
                                    <div className="clone-chart menu-option" onClick={this.props.cloneWidget}>
                                        <span>Clone Chart</span>
                                        <CloneIcon />
                                    </div>
                                </>
                            )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && <DeleteWidget onClick={this.props.deleteWidget} />}
                    </ChartOptionsSidebar>
                )}
                {!nodata ? (
                    <div className="dashboard-chart skiptranslate" ref={this.chartEl}>
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={this.getOptions()}
                            ref={this.chartComponent}
                            containerProps={{ style: { width: "100%", height: "100%" } }}
                        />
                    </div>
                ) : (
                    <NoData
                        message={
                            !this.props.isPublic && this.props.noTopicsSelected
                                ? "To view charts, please select topics using either the page filters on the left or the chart filters on this chart."
                                : null
                        }
                    />
                )}
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        // allPlatforms: state.globalReducer.filterOptions ? state.globalReducer.filterOptions.platforms : [],
        allPlatforms: state.filterSettingReducer.masterPlatforms,
        widgetListDashboardCurrent: state.dashboardReducer.widgetListDashboardCurrent,
        maximizeWidgetValue: state.dashboardReducer.maximizeWidgetValue,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showChartsDrilldown: (bool, name) => dispatch(showChartsDrilldown(bool, name)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PositiveSentimentPercentOverTime);
